let configuration = envConfig;

if (envConfig.environment !== 'dev') {
  configuration = window['envConfig'];
}

export const config = configuration;
